import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLAIMREQUESTS_FEATURE_KEY,
  ClaimRequestsState,
  claimRequestEntityAdapter
} from './claim-requests.reducer';

// Lookup the 'ClaimRequests' feature state managed by NgRx
const getClaimRequestsState = createFeatureSelector<ClaimRequestsState>(
  CLAIMREQUESTS_FEATURE_KEY
);

export const {
  selectIds: getClaimRequestIds,
  selectEntities: getClaimRequestEntities,
  selectAll: getAllClaimRequests,
  selectTotal: getTotalClaimRequests
} = claimRequestEntityAdapter.getSelectors(getClaimRequestsState);

const getLoaded = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.loaded
);
const getError = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.error
);

const getSelectedId = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.selectedId
);

const getSelectedSearchByIdNumberIds = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.searchByIdNumberIds
);

const getSelectedListByIdNumberIds = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByIdNumberIds
);

const getSelectedListByStatusIds = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByStatusIds
);

const getSelectedListForSupervisorByStatusIds = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listForSupervisorByStatusIds
);

const getSelectedListByAssigneeIds = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByAssigneeIds
);

const getSelectedSearchByIdNumberPage = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.searchByIdNumberPagination
);

const getSelectedListByIdNumberPage = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByIdNumberPagination
);

const getSelectedListByStatusPage = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByStatusPagination
);

const getSelectedListForSupervisorByStatusPage = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listForSupervisorByStatusPagination
);

const getSelectedListByAssigneePage = createSelector(
  getClaimRequestsState,
  (state: ClaimRequestsState) => state.listByAssigneePagination
);

const getSelectedClaimRequest = createSelector(
  getClaimRequestEntities,
  getSelectedId,
  (claimRequests, id) => {
    const result = claimRequests[id];
    return result ? Object.assign({}, result) : undefined;
  }
);

const getSelectedSearchByIdNumberClaimRequests = createSelector(
  getClaimRequestEntities,
  getSelectedSearchByIdNumberIds,
  (claimRequests, ids) => {
    const result = ids.map(id => claimRequests[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedListByIdNumberClaimRequests = createSelector(
  getClaimRequestEntities,
  getSelectedListByIdNumberIds,
  (claimRequests, ids) => {
    const result = ids.map(id => claimRequests[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedListByStatusClaimRequests = createSelector(
  getClaimRequestEntities,
  getSelectedListByStatusIds,
  (claimRequests, ids) => {
    const result = ids.map(id => claimRequests[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedListForSupervisorByStatusClaimRequests = createSelector(
  getClaimRequestEntities,
  getSelectedListForSupervisorByStatusIds,
  (claimRequests, ids) => {
    const result = ids.map(id => claimRequests[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedListByAssigneeClaimRequests = createSelector(
  getClaimRequestEntities,
  getSelectedListByAssigneeIds,
  (claimRequests, ids) => {
    const result = ids.map(id => claimRequests[id]);
    return result ? Object.assign([], result) : [];
  }
);

export const claimRequestsQuery = {
  getLoaded,
  getError,
  getAllClaimRequests,
  getSelectedSearchByIdNumberPage,
  getSelectedListByIdNumberPage,
  getSelectedListByStatusPage,
  getSelectedListForSupervisorByStatusPage,
  getSelectedListByAssigneePage,
  getSelectedClaimRequest,
  getSelectedSearchByIdNumberClaimRequests,
  getSelectedListByIdNumberClaimRequests,
  getSelectedListByStatusClaimRequests,
  getSelectedListForSupervisorByStatusClaimRequests,
  getSelectedListByAssigneeClaimRequests
};
